module.exports = __webpack_public_path__ + "img/ic_favorited_sparks.370a103a.png";